import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import TagHero from 'flarum/tags/forum/components/TagHero';
import Model from 'flarum/common/Model';
import Tag from 'flarum/tags/common/models/Tag';

// Register the new attribute on the Tag model so it's accessible in JS
Tag.prototype.backgroundImage = Model.attribute('backgroundImage');

function hexToRgb(hex) {
	const clean = hex.replace('#', '');
	const full = clean.length === 3
		? clean.split('').map(function(c) { return c + c; }).join('')
		: clean;
	if (full.length !== 6) return null;
	const num = parseInt(full, 16);
	return {
		r: (num >> 16) & 255,
		g: (num >> 8) & 255,
		b: num & 255,
	};
}

app.initializers.add('kemze-tag-tint', function() {

	// 1. Tint each discussion row in the list
	extend(DiscussionListItem.prototype, 'elementAttrs', function(attrs) {
		const discussion = this.attrs.discussion;
		const tags = discussion.tags ? discussion.tags() : [];
		if (!tags || !tags.length) return;

		const color = tags[0].color();
		if (!color) return;

		const rgb = hexToRgb(color);
		if (!rgb) return;

		attrs.style = (attrs.style || '') +
			'--tag-color:' + color + ';' +
			'--tag-tint:rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.08);';
		attrs.className = ((attrs.className || '') + ' has-tag-tint').trim();
	});

	extend(TagHero.prototype, 'view', function(vnode) {
		const tag = this.attrs.model;
		if (!tag) return;

		const bgImage = tag.backgroundImage ? tag.backgroundImage() : null;
		const color = tag.color();
		const rgb = color ? hexToRgb(color) : null;

		if (!vnode || !vnode.attrs) return;

		const existingStyle = vnode.attrs.style || {};
		const extraStyle = {};

		if (bgImage) {
			extraStyle['background-image'] = 'url(\'' + bgImage + '\')';
			extraStyle['background-position'] = 'center';
		}

		if (rgb) {
			extraStyle['--tag-color'] = color;
			extraStyle['box-shadow'] = 'inset 0 0 0 9999px rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.75)';
		}

		vnode.attrs.style = Object.assign({}, existingStyle, extraStyle);
	});

	// 3. Left sidebar / tags page cards
	try {
		const TagCard = require('flarum/tags/forum/components/TagCard').default;

		extend(TagCard.prototype, 'elementAttrs', function(attrs) {
			const tag = this.attrs.tag;
			if (!tag) return;

			const color = tag.color();
			if (!color) return;

			const rgb = hexToRgb(color);
			if (!rgb) return;

			attrs.style = (attrs.style || '') +
				'--tag-color:' + color + ';' +
				'--tag-card-tint:rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.10);';
			attrs.className = ((attrs.className || '') + ' has-tag-card-tint').trim();
		});
	} catch(e) {
		console.warn('[kemze-tag-tint] TagCard not available:', e);
	}
	// 4. Discussion hero — tint based on primary tag
	extend(DiscussionHero.prototype, 'view', function(vnode) {
		const discussion = this.attrs.discussion;
		if (!discussion) return;

		const tags = discussion.tags ? discussion.tags() : [];
		if (!tags || !tags.length) return;

		const primaryTag = tags[0];

		// Background image
		const bgImage = primaryTag.backgroundImage ? primaryTag.backgroundImage() : null;

		// Color tint
		const color = primaryTag.color();
		const rgb = color ? hexToRgb(color) : null;

		if (!vnode || !vnode.attrs) return;

		const existingStyle = vnode.attrs.style || {};

		const extraStyle = {};

		if (bgImage) {
			extraStyle['background-image'] = 'url(\'' + bgImage + '\')';
			extraStyle['background-position'] = 'center';
		}

		if (rgb) {
			extraStyle['--tag-color'] = color;
			extraStyle['box-shadow'] = 'inset 0 0 0 9999px rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.75)';
		}

		vnode.attrs.style = Object.assign({}, existingStyle, extraStyle);
	});

});
